// Module
var code = "<ul class=\"landing-page-arrowed-list tw-list-reset\" ng-transclude=\"\"></ul>\n";
// Exports
module.exports = code;